import React, { lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '1',
  title: 'El Despertar del Canal Reiki',
  cover: 'https://cdn.magicpatterns.com/uploads/hthFChpAZWsdKb1Wu6foBT/PAGINA_1.png'
}, {
  num: '2',
  title: 'Chakras y Sanación Energética',
  cover: 'https://cdn.magicpatterns.com/uploads/pPdQEiZzrjLst65NYJMW3L/PAGINA_1.png'
}, {
  num: '3',
  title: 'Técnicas Profesionales de Reiki',
  cover: 'https://cdn.magicpatterns.com/uploads/4TppAiPkrp9K27ckuZidnp/PAGINA_1.png'
}, {
  num: '4',
  title: 'Símbolos y Reiki a Distancia',
  cover: 'https://cdn.magicpatterns.com/uploads/833GR7NJ2yTkrL9aVR8HZ8/PAGINA_1.png'
}, {
  num: '5',
  title: 'Reiki Profesional y Salida Laboral',
  cover: 'https://cdn.magicpatterns.com/uploads/vTcjEDrLmeiTzt7huPkb2Y/PAGINA_1.png'
}, {
  num: '6',
  title: 'Maestría Reiki y Expansión',
  cover: 'https://cdn.magicpatterns.com/uploads/rvtJTTrCzSszFpc4FvTCAm/PAGINA_1.png'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#FAFAF8] py-20 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-217">
      <div className="container mx-auto max-w-6xl" data-id="element-218">
        <div ref={ref1} className={`reveal text-center mb-16 md:mb-24 ${vis1 ? 'is-visible' : ''}`} data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-220">
            Todo lo que vas a aprender
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14" data-id="element-221">
          {TOMOS.map((tomo, idx) => <div key={idx} className="group flex flex-col items-center" data-id="element-222">
              {/* Portada — protagonista */}
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.12)] mb-8 transition-transform duration-500 group-hover:-translate-y-2 group-hover:shadow-[0_30px_60px_rgba(0,0,0,0.18)]" data-id="element-223">
                <img src={tomo.cover} alt={`Portada del Tomo ${tomo.num}: ${tomo.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-224" />
              </div>

              {/* Texto mínimo */}
              <div className="text-center w-full px-4" data-id="element-225">
                <span className="text-[#D4AF37] text-xs font-bold tracking-[0.2em] uppercase mb-3 block" data-id="element-226">
                  Tomo {tomo.num}
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-[#1E2330] leading-snug" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-227">
                  {tomo.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}